export default __webpack_public_path__ + "static/media/9c.43490aa2.png";